import React from 'react';
import CreateOwnershipDialog from 'src/components/project/sections/tract/dialogs/CreateOwnershipDialog';
import CreateSurfaceTractDialog from 'src/components/project/sections/tract/dialogs/CreateTractDialog';
import CopyOwnershipDialog from 'src/components/project/sections/TractComponents/dialogs/CopyOwnershipDialog';
import DeleteAdditionalOwnershipDialog from 'src/components/project/sections/TractComponents/dialogs/DeleteAdditionalOwnershipDialog';
import EastTexasAbstractDialog from 'src/components/project/sections/TractComponents/panels/EastTexasAbstractDialog';
import Abstract from 'src/models/Abstract';
import { SelectItem } from 'src/models/common/SelectItem';
import County from 'src/models/County';
import { LandSystem } from 'src/models/LandSystem';
import SurfaceTract from 'src/models/SurfaceTract';
import Tract from 'src/models/Tract';
import Owner from 'src/models/tract_detail/Owner';
import Ownership from 'src/models/tract_detail/Ownership';
import OwnershipNotesDialog from 'src/components/project/sections/TractComponents/OwnershipNotesDialog';
import AddWIOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddWIOwnership';
import AddOwner from 'src/models/tract_detail/add_ownership_revised/AddOwner';
import AddOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddOwnership';
import TractDetailData from 'src/models/tract_detail/TractDetail';
import AddMineralOwnership from 'src/components/project/sections/TractComponents/AddOwnership.redesign';
import TractNotesDialog from 'src/components/project/sections/TractComponents/TractNotesDialog';
import ContactNoteDialog from 'src/components/project/sections/tract/dialogs/ContactNoteDialog';
import DeleteTractDialog from 'src/components/project/sections/TractComponents/DeleteTractDialog';
import TractDetail from 'src/models/tract_detail/TractDetail';
export type dialogCreator = {
    copyLeasehold: (ownershipId: number, onLeaseholdCopied: (easternMapNumber: number) => void) => void;
    deleteAdditionalOwnership: (ownershipId: number, ownershipName: string, ownerships: Ownership[], owners: Owner[], onComplete: () => void) => void;
    // tslint:disable-next-line: max-line-length
    createTract: (landSystem: LandSystem, fieldNumber: number, isSurfaceProject: boolean, counties: Array<County>, tractType: 'Mineral' | 'Surface', onSurfaceTractCreated: (surfaceTract: SurfaceTract) => void, onMineralTractCreated: (mineralTract: Tract) => void) => void;
    // tslint:disable-next-line: max-line-length
    deleteTract: (horizons: Array<TractDetail>, surfaceOwnerships: Array<SurfaceTract>, navigate: () => void, confirmDelete: () => void, onCloseDialog: () => void, onCloseDeleteTractDialog: () => void, tractType: number) => void;
    createSurfaceOwnership: (tractId: number, parentOwnershipId?: number, onOwnershipCreated?: (ownership: Ownership) => void) => void;
    createMineralOwnership: (title: string, dialogType: string, addDeviation: (values: AddOwner, containerOwnerId: number, ownerType: string) => void, navigate: (path: string) => void, 
                             saveAddLeaseOwnership: (values: AddWIOwnershipData) => void, saveAddTractOwnership: (data: AddOwnershipData) => void, tract: TractDetailData, horizon: number,
                             parentOwnershipId: number) => void;
    addEastTexasAbstract: (counties: SelectItem[], onAbstractSelected: (abstract: Abstract) => void) => void;
    openContactNotes: (ownership?: Ownership, createNewNote?: boolean, projectType?: 'Mineral' | 'Surface', refreshContainer?: () => void) => void;
    // tslint:disable-next-line: max-line-length
    openOwnershipNotes: (ownership: Ownership, owners: Array<Owner>, errorMessage: string, context: number, updateOwnershipNote: (note: Ownership) => void, selectedWIOwnershipId?: number) => void;
    // tslint:disable-next-line: max-line-length
    openTractNotes: (tract: TractDetailData | undefined, surfaceTract: SurfaceTract | undefined, errorMessage: string, updateTractNote: (horizon: TractDetailData) => void, updateSurfaceTractNote: (surfaceTract: SurfaceTract) => void, clearError: () => void) => void;
};

const creators = (setDialog: (element: React.ReactElement) => void): dialogCreator => {
    return {
        copyLeasehold: (ownershipId: number, onLeaseholdCopied: (id: number) => void) => {
            setDialog(
                React.createElement(CopyOwnershipDialog, {
                    ownershipId,
                    onLeaseholdCopied,
                })
            );
        },
        deleteAdditionalOwnership: (ownershipId: number, ownershipName: string, ownerships: Ownership[], owners: Owner[], onComplete: () => void) => {
            setDialog(
                React.createElement(DeleteAdditionalOwnershipDialog, {
                    ownershipId,
                    ownershipName,
                    ownerships,
                    owners,
                    onComplete,
                })
            );
        },
        // tslint:disable-next-line: max-line-length
        deleteTract: (
                horizons: Array<TractDetail>,
                childSurfaceTracts: Array<SurfaceTract>,
                navigate: () => void,
                confirmDelete: () => void,
                onCloseDialog: () => void,
                onCloseDeleteTractDialog: () => void,
                tractType: number) => {
            setDialog(
                React.createElement(DeleteTractDialog, {
                    navigate,
                    confirmDelete,
                    onCloseDialog,
                    horizons,
                    childSurfaceTracts,
                    onCloseDeleteTractDialog,
                    tractType
                })
            );
        },
        // tslint:disable-next-line: max-line-length
        createTract: (landSystem: LandSystem, fieldNumber: number, isSurfaceProject: boolean, counties: Array<County>, tractType: 'Mineral' | 'Surface', onSurfaceTractCreated: (surfaceTract: SurfaceTract) => void, onMineralTractCreated: (mineralTract: Tract) => void) => {
            setDialog(
                React.createElement(CreateSurfaceTractDialog, {
                    landSystem,
                    fieldNumber,
                    isSurfaceProject,
                    counties,
                    tractType,
                    onSurfaceTractCreated: onSurfaceTractCreated,
                    onMineralTractCreated: onMineralTractCreated
                })
            );
        },
        createSurfaceOwnership: (surfaceTractId: number, parentOwnershipId?: number, onOwnershipCreated?: (ownership: Ownership) => void) => {
            setDialog(
                React.createElement(CreateOwnershipDialog, {
                    tractId: surfaceTractId,
                    parentOwnershipId: parentOwnershipId,
                    onOwnershipCreated: onOwnershipCreated,
                })
            );
        },
        createMineralOwnership: (title: string, dialogType: string, addDeviation: (values: AddOwner, containerOwnerId: number, ownerType: string) => void, navigate: (path: string) => void, 
                                 saveAddLeaseOwnership: (values: AddWIOwnershipData) => void, saveAddTractOwnership: (data: AddOwnershipData) => void, tract: TractDetailData, horizon: number,
                                 parentOwnershipId: number) => {
            setDialog(
                React.createElement(AddMineralOwnership, {
                    dialogType: dialogType,
                    title: title,
                    tract: tract,
                    horizon: horizon,
                    parentOwnershipId: parentOwnershipId,
                    navigate: navigate,
                    saveAddLeaseOwnership: saveAddLeaseOwnership,
                    saveAddTractOwnership: saveAddTractOwnership,
                    addDeviation: addDeviation
                })
            );
        },
        addEastTexasAbstract: (counties: SelectItem[], onAbstractSelected: (abstract: Abstract) => void) => {
            setDialog(
                React.createElement(EastTexasAbstractDialog, {
                    counties,
                    onAbstractSelected,
                })
            );
        },
        openContactNotes: (ownership?: Ownership, createNewNote?: boolean, projectType?: 'Mineral' | 'Surface', refreshContainer?: () => void) => {
            setDialog(
                React.createElement(ContactNoteDialog, {
                    ownership,
                    createNewNote,
                    projectType,
                    refreshContainer,
                })
            );
        },
        // tslint:disable-next-line: max-line-length
        openOwnershipNotes: (ownership: Ownership, owners: Array<Owner>, errorMessage: string, context: number, updateOwnershipNote: (note: Ownership) => void, selectedWIOwnershipId?: number) => {
            setDialog(
                React.createElement(OwnershipNotesDialog, {
                    ownership,
                    owners,
                    errorMessage,
                    context,
                    updateOwnershipNote,
                    selectedWIOwnershipId
                })
            );
        },
        // tslint:disable-next-line: max-line-length
        openTractNotes: (tract: TractDetailData | undefined, surfaceTract: SurfaceTract | undefined, errorMessage: string, updateTractNote: (horizon: TractDetailData) => void, updateSurfaceTractNote: (surfaceTract: SurfaceTract) => void, clearError: () => void) => {
            setDialog(
                React.createElement(TractNotesDialog, {
                    tract,
                    surfaceTract,
                    errorMessage,
                    updateTractNote,
                    updateSurfaceTractNote,
                    clearError
                })
            );
        }
    };
};

export default creators;



// WEBPACK FOOTER //
// ./src/providers/dialogs/tract.ts